import * as React from 'react';
import * as Locale from '../model/locale';
import Formsy from 'formsy-react';
import {Input, Select, Row} from 'formsy-react-components';
import {SubmitButton} from './forms';
import {Validations} from '../model/forms';
import {updateUserSettings, UserData} from '../model/account';
import {connect} from "react-redux";
import {Subheading} from "./subheading";
import {Button} from 'react-bootstrap';
import * as MomentTimezone from 'moment-timezone';
import {isEmpty} from 'underscore';
import {ACCOUNT_ROUTE_PASSWORD} from '../model/routes/main';
import * as phoneNumber from "google-libphonenumber";

export interface SettingsFormFieldsProps {
    onSubmit: Function;
    textForKey: Function;
    userData: UserData;
}


export class SettingsForm extends React.Component<SettingsFormFieldsProps, any> {
    state: {
        canSubmit: boolean;
    };
    static getTimezones() {
        return MomentTimezone.tz.names().map(function (obj) {
            return {value: obj, label: obj};
        });
    }
    static getLanguages(languages: { [key: string]: Locale.Language; } ) {
        let out = [];
        Object.keys(languages).forEach(lang => {out.push({label: languages[lang].displayName, value: lang}); });
        return out;
    }
    static isLang(lang: string) {
        return !(Locale.AvailableLanguages[lang] === null);
    }
    static isTimezone(timezone: string) {
        try {
            MomentTimezone.tz(timezone);
            return true;
        }catch (e) {
            return false;
        }
    }
    static getAvailableUnitsOfMeasurement(unitsOfMeasurement: { [key: string]: Locale.UnitOfMeasurement; }, textForKey ) {
        let out = [];
        Object.keys(unitsOfMeasurement).forEach(
            unit => {out.push({label: textForKey(unitsOfMeasurement[unit].displayName), value: unit}); });
        return out;
    }
    static  isAvailableUnitsOfMeasurement(unit: string) {
        return !(Locale.AvailableUnitsOfMeasurement[unit] === null);
    }

    static cleanPhoneNumber(mobile) {
        mobile = mobile.trim(mobile);
        if (mobile.length > 0) {
            let phoneUtil = phoneNumber.PhoneNumberUtil.getInstance();
            let parsedNumber = phoneUtil.parseAndKeepRawInput(mobile);
            mobile = phoneUtil.format(parsedNumber, phoneNumber.PhoneNumberFormat.E164);
        }
        return mobile;
    }
    constructor() {
        super();
        this.state = {
            canSubmit: false
        };
    }
    formChanged(currentValues) {
        this.setState({
            selectedTimezone: currentValues.timezone,
            selectedLanguage: currentValues.language,
            selectedEmail: currentValues.email,
            selectedMobile: currentValues.mobile

        });
    }
    enableButton() {
        this.setState({
            canSubmit: true
        });
    }
    disableButton() {
        this.setState({
            canSubmit: false
        });
    }
    render() {
        let {textForKey, userData, onSubmit} = this.props;
        let selectedTimezone = userData.timezone;
        return (
            <Formsy.Form className="form-horizontal"
                         onValid={this.enableButton.bind(this)}
                         onInvalid={this.disableButton.bind(this)}
                         onChange={this.formChanged.bind(this)}
                         onValidSubmit={onSubmit}>

                <Input label={textForKey(Locale.TEXT_USER_EMAIL)}
                       name="email"
                       value={userData.email}
                       validations={Validations.userSettingsEmail.validator}
                       validationErrors={Validations.userSettingsEmail.messages(textForKey)}
                       placeholder={textForKey(Locale.TEXT_SAMPLE_EMAIL)}
                />
                <Select label={textForKey(Locale.TEXT_TIMEZONE)}
                       name="timezone"
                       options={SettingsForm.getTimezones()}
                        value={selectedTimezone}
                        validations={SettingsForm.isTimezone}
                       required />
                <Select label={textForKey(Locale.TEXT_DEFAULT_TEMPERATURE_UM)}
                        name="temperature_uom"
                        value={userData.temperature_uom}
                        options={SettingsForm.getAvailableUnitsOfMeasurement(Locale.AvailableUnitsOfMeasurement, textForKey)}
                        validations={SettingsForm.isAvailableUnitsOfMeasurement}
                        />
                <Select label={textForKey(Locale.TEXT_USER_SELECT_LANGUAGE)}
                        name="language"
                        value={userData.language}
                        options={SettingsForm.getLanguages(Locale.AvailableLanguages)}
                        validations={SettingsForm.isLang}
                       required />
                <Input label={textForKey(Locale.TEXT_LABEL_MOBILE)}
                       value={userData.mobile}
                       validations={Validations.userSettingsMobile.validator}
                       validationErrors={Validations.userSettingsMobile.messages(textForKey)}
                       name="mobile"
                       placeholder={textForKey(Locale.TEXT_SAMPLE_MOBILE)}
                />
                <Row layout="horizontal">
                    <SubmitButton disabled={!this.state.canSubmit}
                                  defaultValue={textForKey(Locale.TEXT_MODAL_BUTTON_SAVE)} />
                </Row>
                <Row layout="horizontal">
                    <Button href={ACCOUNT_ROUTE_PASSWORD} type="button">{textForKey(Locale.TEXT_CHANGE_PASSWORD)}</Button>
                </Row>
            </Formsy.Form>
        );
    }
}
export interface SettingsPageFieldsProps {
    dispatch?: Function;
    textForKey?: Function;
    userData: UserData;
    status;
}
@connect(
    state => ({
        ui: state.ui,
        textForKey: state.data.textForKey,
        userData: state.data.user,
    })
)
export class SettingsPage extends React.Component<SettingsPageFieldsProps, any> {
    submitChanges(data) {
        let {dispatch} = this.props;
        data.mobile = SettingsForm.cleanPhoneNumber(data.mobile);
        if (!(isEmpty(data))) {
            dispatch(updateUserSettings(data));
        }
    }
    render () {
        let {textForKey, userData} = this.props;
        let userSubmit = this.submitChanges.bind(this);
        return (
            <div className="container content">
                <Subheading title={textForKey(Locale.TEXT_TITLE_USER_SETTINGS)}/>
                <div className="form col-md-10 col-md-offset-1 col-sm-12 col-sm-offset-0">
                    <SettingsForm
                        textForKey={textForKey}
                        userData={userData}
                        onSubmit={userSubmit}/>

                </div>
            </div>
        );
    }
}
